import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ group, resource }) =>
    present(
      repository
        .removeResourceFromResourceGroup(resource, group)
        .then(() => ({ resource, group }))
        .catch(() => Promise.reject({ resource, group })),
    );
}

export type { Interactor };

export { createInteractor };
